<app-drop-down-single-con-id *ngIf="tipoDocs.length > 0"
                             [data]="tipoDocs"
                             (elementoSeleccionado)="actualizaFiltroTipoDocumento($event)"
                             [valorPreSeleccionado]="tipoDocSeleccionado"
                             [width]="'230px'"
                             [height]="'30px'"></app-drop-down-single-con-id>
